module.exports = __webpack_public_path__ + "static/img/home-hot7.93474cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-hot7.png
// module id = SjTQ
// module chunks = 21